import { Container } from '@cgs/wge';
import { CheatManager, CheatManagerToken } from '../cheat-manager';
import { CheatPopupElementToken } from './cheat-popup';
import { CheatUISection } from './cheat-ui-section';
import { getCheatUIStyles } from './styles';

export const CheatCommandsToken = Symbol('CheatCommands');

export class CheatCommandsUI extends CheatUISection {
  constructor(private container: Container) {
    super();

    const cheatCommands = this.container.resolve<string[] | null>(CheatCommandsToken);

    if (!cheatCommands?.length) {
      return;
    }

    this.initialize();
  }

  public initialize(): void {
    const consoleEl = this.container.resolve<HTMLDivElement>(CheatPopupElementToken);

    this.initializeBaseUI(consoleEl);
    this.setupCommandsUI();
    this.setupCommandsEventListeners();
  }

  private setupCommandsUI(): void {
    const cheatCommands = this.container.resolve<string[]>(CheatCommandsToken);

    const styles = getCheatUIStyles();
    const content = `
      <div id="commands" style="${styles.sectionStyle}">
        ${cheatCommands.map(
          (command) =>
            `<button id="${command}" style="${styles.buttonStyle}">${this.formatCommandText(
              command
            )}</button>`
        )}
      </div>
    `;

    this.contentEl.innerHTML = content;
  }

  private setupCommandsEventListeners(): void {
    const cheatCommands = this.container.resolve<string[]>(CheatCommandsToken);
    const cheatManager = this.container.resolve<CheatManager>(CheatManagerToken);

    cheatCommands.forEach((command) => {
      this.getChildEl(`#${command}`)?.addEventListener('click', () => {
        cheatManager.applyCommand(command);
      });
    });
  }

  private formatCommandText(command: string): string {
    return command
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  }
}
